import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authActions from '../../redux/auth/actions';
import modalsActions from '../../redux/modals/actions';
import Login from './Login';

const mapStateToProps = ({ modals }) => ({
  isPrivacyPolicyModalOpen: modals.isPrivacyPolicyModalOpen,
  isTermsOfServiceModalOpen: modals.isTermsOfServiceModalOpen,
  isPlatformAgreementsModalOpen: modals.isPlatformAgreementsModalOpen,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logIn: authActions.logIn,
      resetErrors: authActions.resetErrors,
      togglePrivacyPolicyModal: modalsActions.togglePrivacyPolicyModal,
      toggleTermsOfServiceModal: modalsActions.toggleTermsOfServiceModal,
      togglePlatformAgreementsModal: modalsActions.togglePlatformAgreementsModal,
      acceptTermsAndPolicy: authActions.acceptTermsAndPolicy,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
